/*!
 * Copyright (c) 2018, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { Component, OnInit, Injectable, Pipe, PipeTransform} from '@angular/core';
import { OktaAuthService } from '@okta/okta-angular';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml, SafeUrl } from '@angular/platform-browser';
import { environment } from './../../environments/environment';

interface ResourceServerExample {
  label: string;
  url: string;
}

interface Claim {
  claim: string;
  value: string;
}

@Pipe({
  name: 'safeUrl'
})
export class SafeUrlPipe implements PipeTransform {
  constructor(private _sanitizer:DomSanitizer) {
  }
  transform(v:string):SafeHtml {
    return this._sanitizer.bypassSecurityTrustUrl(v);
  }
}

@Injectable()
export class RegistrationService {
  url: SafeUrl;

  constructor(private http: HttpClient, private _sanitizer:DomSanitizer) {

  }

  load(accessToken: string, userName: string) {
    let promise = new Promise((resolve, reject) => {
      
      console.log(environment.apiUrl);
      let apiRegURL = environment.apiUrl+"registration";
      this.http
        .get(apiRegURL,{headers: {Authorization: 'Bearer ' + accessToken}})
        .toPromise()
        .then(
          res => {
            resolve();
          },
          msg => {
            // Error
            reject(msg);
          }
        );
    });
    return promise;
  }
}


@Injectable()
export class WorkspaceService {
  url: SafeUrl;

  constructor(private http: HttpClient, private _sanitizer:DomSanitizer) {

  }

  load(accessToken: string, userName: string) {
    let promise = new Promise((resolve, reject) => {
       // Success
      console.log(environment.apiUrl);
      let apiWSURL = environment.apiUrl+"workspaces-code";
      this.http
        .get(apiWSURL,{headers: {Authorization: 'Bearer ' + accessToken}})
        .toPromise()
        .then(
          resp => {
           // Success
            this.url  = this._sanitizer.bypassSecurityTrustUrl("workspaces://"+userName+"@"+resp["body"]["regCode"]+"?MFACode="+resp["body"]["totpval"]);
            resolve();
          },
          msg => {
           // Error
           reject(msg);
          }
        );
    });
    return promise;
  }
}

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  userName: string;
  isAuthenticated: boolean;
  error: Error;
  claims: Array<Claim>;
  accessToken: string;
  loading: boolean = false;

  constructor(public oktaAuth: OktaAuthService, private http: HttpClient, private workspaceService: WorkspaceService, private registrationService: RegistrationService) {
    this.oktaAuth.$authenticationState.subscribe(isAuthenticated => this.isAuthenticated = isAuthenticated);
  }

  async login() {
    try {
      await this.oktaAuth.signInWithRedirect();
    } catch (err) {
      console.error(err);
      this.error = err;
    }
  }

  async ngOnInit() {
    this.loading = true;
    this.isAuthenticated = await this.oktaAuth.isAuthenticated();
    if (this.isAuthenticated) {
      const userClaims = await this.oktaAuth.getUser();
      this.userName = userClaims.name;
      this.claims = Object.entries(userClaims).map(entry => ({ claim: entry[0], value: entry[1] }));

      this.accessToken = this.oktaAuth.getAccessToken();
      console.log(this.accessToken);
      this.registrationService.load(this.accessToken, this.userName).then(
        _ => this.workspaceService.load(this.accessToken, this.userName).then(_ => (this.loading = false))
      );
    }
  }
}
